<template>
	<QuestionGroup data-testid="s3-file-naming-step">
		<QuestionCard
			title="Do you want to use a customised file name format?"
			:description="formatDescription"
			:show-yes-no-buttons="true"
			:value="useCustomFileName"
			:disabled="!userFullPermissions"
			data-testid="s3-file-naming-toggle"
			@input="handleToggle"
		/>
		<QuestionCard
			v-if="useCustomFileName"
			title="Which field should we use in the filename?"
			:description="cleaningDescription"
		>
			<Dropdown
				label="Filename Field *"
				:value="customFileNameField"
				:items="filenameFieldItems"
				:disabled="!userFullPermissions"
				rules="required"
				class="filename-field-dropdown"
				data-testid="s3-filename-field-dropdown"
				@input="$emit('update:customFileNameField', $event)"
			/>
			<p
				v-if="!filenameFieldItems.length"
				class="filename-field-empty"
				data-testid="s3-filename-no-fields-message"
			>
				None of the fields selected in step 1 can be used in a file name. Go back and
				include a text or number field.
			</p>
		</QuestionCard>
	</QuestionGroup>
</template>

<script>
import Dropdown from '../../../../../../../shared/components/dropdown.vue'
import { QuestionCard, QuestionGroup } from '../../../../../components/component-library-wrapper.js'
import { buildFilenameFieldOptions } from '../utils/filename-field-options.js'

export default {
	components: { Dropdown, QuestionCard, QuestionGroup },
	props: {
		useCustomFileName: Boolean,
		customFileNameField: String,
		selectedFields: {
			type: Array,
			default: () => []
		},
		availableFields: {
			type: Array,
			default: () => []
		},
		userFullPermissions: Boolean
	},
	computed: {
		formatDescription () {
			return 'Files generated directly to S3 are named using the format ' +
				'[serviceid]_[runid]_[epoch].json by default, allowing them to be processed in the ' +
				'correct order. You can also include a value from one of the available fields to ' +
				'help identify files during your own processing.'
		},
		cleaningDescription () {
			return 'The selected value will be cleaned before being added to the file name. It will ' +
				'be converted to lower case, and letters, numbers, spaces and the symbols ( ) @ . - _ # ' +
				'are preserved. Any other characters are removed automatically.'
		},
		filenameFieldItems () {
			return buildFilenameFieldOptions(this.availableFields, this.selectedFields)
		}
	},
	methods: {
		handleToggle (value) {
			this.$emit('update:useCustomFileName', value)
			// Clear the field when switching off so a disabled service cannot save a stale
			// selection that the server-side validator would then reject.
			if (!value) {
				this.$emit('update:customFileNameField', null)
			}
		}
	}
}
</script>

<style scoped>
.filename-field-empty {
	color: var(--v-error-base);
	font-size: 0.875rem;
	margin-top: 0.5rem;
}
</style>
